import React, {Fragment} from 'react';
import Navbar2 from '../../components/Navbar2'
import PageTitle from '../../components/pagetitle'
import About2 from '../../components/about2'
import Services2 from '../../components/Services2'
import FunFact from '../../components/FunFact'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import VisionMission from '../../components/VisionMission/VisionMission';


const AboutPage =() => {
    return(
        <Fragment>
            <Navbar2/>
            <PageTitle pageTitle={'About Us'} pagesub={'About'}/> 
            <About2 abClass={'wpo-about-section-s2'}/>
            <VisionMission/>
            <Services2 srvClass={'wpo-service-section-s3'}/>
            <FunFact fnClass={'wpo-fun-fact-section-s2'}/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default AboutPage;
